'use strict'

/**
 * Module qui gère l'animation des texts
 */

import gsap from 'gsap'

function startMarqueeAnimation(selector) {
    const rows = document.querySelectorAll(selector)

    rows.forEach(function (e, i) {
        let row_width = e.getBoundingClientRect().width
        let row_item_width = e.children[0].getBoundingClientRect().width
        let initial_offset = ((2 * row_item_width) / row_width) * 100 * -1

        gsap.set(e, {
            xPercent: `${initial_offset}`
        })

        let duration = 100 * (i + 1)

        var tl = gsap.timeline()

        tl.to(e, {
            ease: 'none',
            duration: duration,
            xPercent: 0,
            repeat: -1
        })
    })
}

function init() {
    startMarqueeAnimation('.marquee-row')
    startMarqueeAnimation('.footer__anim-wrapper')
}

function initFooter() {
    startMarqueeAnimation('.footer__anim-wrapper')
}

export default {
    init: init,
    initFooter: initFooter
}
